import { useEffect, useState } from 'react'
import ReactDOM from "react-dom";
import Backdrop from '../../../common/modal/Backdrop';
import Modal from '../../../common/Modal';
import ModalInnerWrapper from '../../../common/ModalInnerWrapper';
import PannelBody from '../../../fragments/PannelBody';
import TextareaBox from '../../../common/interactive/TextareaBox';
import Button from '../../../common/Button';
import { resolveAlert } from '../../../../lib/fetchApi';
import { useDispatch, useSelector } from 'react-redux';
import { notificationActions } from '../../../../store/notifications';
import { caseActions } from '../../../../store/case';

export default function ResolveAlerts({showResolveTask, openResolveTask, itemData}) {
    const [loadResolve, setLoadResolve] = useState(false)

    const dispatch = useDispatch()

    const activeCase = useSelector(state => state.case.activeCase)  
    const userToken = useSelector(state => state.user.token)

    const resolveTaskHandler = async (event) => {
        event.preventDefault()
        setLoadResolve(true)
        try {
            const fd = new FormData(event.target)

            const formData = Object.fromEntries(fd.entries())

            let reqBody = {
                note: formData.resolve_notes
            }

            let resolve = await resolveAlert(userToken, activeCase.case.id, itemData?.id, reqBody)
            if (resolve && resolve.errorMessage) {
                dispatch(notificationActions.setError(resolve))     
            } else {            
                dispatch(notificationActions.setError({errorMessage: `Alert Resolved`, type: 'success'}))    
                
                let dispatchBody = {
                    folder: 'case_alerts',
                    itemId: resolve?.id,
                    item: resolve
                }   
                dispatch(caseActions.pushWholeItemInArray(dispatchBody)) 

                if (openResolveTask) {
                    openResolveTask()
                }
            }
        } finally {
            setLoadResolve(false)
        }
    }

    useEffect(() => {
        if (!showResolveTask) return;
        const rafId = requestAnimationFrame(() => {
            const el = document.getElementById("resolve_notes");
            if (el && typeof el.focus === "function") {
                el.focus();
            }
        });
        return () => cancelAnimationFrame(rafId);
    }, [showResolveTask]);

    return <>
        {showResolveTask && <>
            {ReactDOM.createPortal(
                <Backdrop hide={openResolveTask} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={openResolveTask} modalTitle={'Resolve Alert'}>
                        <PannelBody>
                            <form onSubmit={resolveTaskHandler}>
                                <div className="row">
                                    <TextareaBox label={'notes'} name={'resolve_notes'} required={true}/>
                                </div>
                                <div className="row">
                                    <Button type={'submit'} isLoading={loadResolve}>Resolve alert</Button>
                                </div>
                            </form>
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}